import { render } from "./GovSection.vue?vue&type=template&id=88788d0c&scoped=true"
import script from "./GovSection.vue?vue&type=script&lang=js"
export * from "./GovSection.vue?vue&type=script&lang=js"

import "./GovSection.vue?vue&type=style&index=0&id=88788d0c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88788d0c"]])

export default __exports__